import { render, staticRenderFns } from "./DSCard.vue?vue&type=template&id=021dfe9f&scoped=true"
import script from "./DSCard.vue?vue&type=script&lang=js"
export * from "./DSCard.vue?vue&type=script&lang=js"
import style0 from "./DSCard.vue?vue&type=style&index=0&id=021dfe9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021dfe9f",
  null
  
)

export default component.exports